import React from "react";

const MainLogo = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      version='1.1'
      id='Layer_1'
      width='40px'
      height='40px'
      viewBox='0 0 64 55'
      enableBackground='new 0 0 64 55'
    >
      <g xmlns='http://www.w3.org/2000/svg' id='Page-1'>
        <g id='Scissors' transform='translate(1.000000, 2.000000)'>
          <path
            id='Shape'
            fill='none'
            stroke='#ffffff'
            stroke-width='2'
            d='M30.5,21.4    C43.3,11.5,58.7-0.5,58.7-0.5C59.8,1,48.142,17.166,38.042,26.766'
          />
          <path
            id='Shape_1_'
            fill='none'
            stroke='#ffffff'
            stroke-width='2'
            d='M23.1,27.3    c-2.6,2.1-4.9,3.8-6.4,5.1c-1.7-1.2-3.8-2-6.2-2C4.7,30.4,0,35,0,40.7S4.7,51,10.5,51s10.6-4.6,10.6-10.3c0-2-0.7-3.9-1.8-5.5    c2.8-1,5.8-1.7,5.8-1.7c1.4,0.6,3.1,0.1,5.2-1'
          />
          <path
            id='Shape_2_'
            fill='none'
            stroke='#ffffff'
            stroke-width='2'
            d='M51.4,30.4    c-2.3,0-4.4,0.7-6.2,2C35.8,24.9,3-0.4,3-0.4C1.2,1.9,27.7,37,36.7,33.6c0,0,3.1,0.6,5.8,1.7c-1,1.6-1.6,3.5-1.6,5.5    c0,5.7,4.7,10.3,10.5,10.3S62,46.5,62,40.8C62,35,57.2,30.4,51.4,30.4L51.4,30.4z'
          />

          <ellipse
            id='Oval_1_'
            fill='none'
            stroke='#ffffff'
            stroke-width='2'
            cx='10.4'
            cy='41.2'
            rx='6.4'
            ry='6.2'
          ></ellipse>

          <ellipse
            id='Oval_2_'
            fill='none'
            stroke='#ffffff'
            stroke-width='2'
            cx='51.3'
            cy='41.2'
            rx='6.3'
            ry='6.2'
          ></ellipse>
          <circle
            id='Oval'
            fill='none'
            stroke='#ffffff'
            stroke-width='2'
            cx='31'
            cy='26'
            r='1'
          ></circle>
        </g>
      </g>
    </svg>
  );
};

export default MainLogo;
